export const REQUEST_DELETE_USER = 'REQUEST_DELETE_USER';
export const REQUEST_DELETE_USER_SUCCESS = 'REQUEST_DELETE_USER_SUCCESS';
export const REQUEST_DELETE_USER_FAILED = 'REQUEST_DELETE_USER_FAILED';

export const REQUEST_EMAIL_VERIFICATION = 'REQUEST_EMAIL_VERIFICATION';
export const REQUEST_EMAIL_VERIFICATION_SUCCESS = 'REQUEST_EMAIL_VERIFICATION_SUCCESS';
export const REQUEST_EMAIL_VERIFICATION_FAILED = 'REQUEST_EMAIL_VERIFICATION_FAILED';